'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["group", "usedFormFieldIds", "dataId", "groupType", "defaultOpen"];
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import PropertiesList from './PropertiesList';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesTree = _ref => {
  let {
      group: {
        label = '',
        properties = []
      },
      usedFormFieldIds = {},
      dataId = '',
      groupType = '',
      defaultOpen = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hasProperties = defaultOpen || properties.length > 0;
  return /*#__PURE__*/_jsx(AccordionItem, {
    defaultOpen: hasProperties,
    title: /*#__PURE__*/_jsx("span", {
      "data-test-id": `${dataId.toLowerCase()}-inner-accordion`,
      children: `${label} (${properties.length})`
    }),
    "data-test-property-group-type": groupType.toUpperCase(),
    "data-test-property-group-name": dataId.toLowerCase(),
    disabled: !hasProperties,
    marginBlockEnd: "100",
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsx(PropertiesList, Object.assign({
      properties: properties,
      usedFormFieldIds: usedFormFieldIds
    }, rest))
  });
};
export default PropertiesTree;